import type { NavigationGuardNext, RouteLocationNormalized } from "vue-router";

/**
 * 移动端路由守卫
 */

/**
 * 移动端返回按钮处理
 */
export const mobileBackGuard = (
  _to: RouteLocationNormalized,
  _from: RouteLocationNormalized,
  next: NavigationGuardNext
) => {
  // 标记成“已使用”，避免 TS6133
  // void to;
  // void from;

  // 可以在这里添加移动端特定的路由逻辑
  // 例如：记录路由历史、处理返回按钮等
  next();
};

/**
 * 移动端页面标题设置
 */
export const setMobileTitle = (title: string) => {
  document.title = title;
  // iOS 特殊处理
  if (/iPhone|iPad|iPod/i.test(navigator.userAgent)) {
    const iframe = document.createElement("iframe");
    iframe.style.display = "none";
    iframe.src = "/favicon.ico";
    const iframeCallback = () => {
      setTimeout(() => {
        iframe.removeEventListener("load", iframeCallback);
        document.body.removeChild(iframe);
      }, 0);
    };
    iframe.addEventListener("load", iframeCallback);
    document.body.appendChild(iframe);
  }
};
